import { API } from '@Providers';

export interface FosterEquipmentRentalLineCheckoutPayload {
  line_id: string;
  rental_agreement_id: string;
  rental_start_date: string;
  due_date: string;
  rental_notes: string;
  agreement_title: string;
  agreement_body: string;
  signature?: string;
}

interface CompleteFosterManualCheckoutPayload {
  cart_id: string;
  foster_contract_id: string;
  foster_animals_waivers?: Array<{
    animal_id: string;
    waiver_ids: string[];
    reserve_kennel_spot?: boolean;
    start_date?: string;
    start_foster_notes?: string;
    start_foster_reason?: string;
    start_foster_reason_id?: string;
  }>;
  equipment_rental_lines?: FosterEquipmentRentalLineCheckoutPayload[];
}

export default async function (payload: CompleteFosterManualCheckoutPayload) {
  const endpoint = '/api/shelter/cart/complete-foster-manual-checkout';

  return API({ endpoint, method: 'post', payload });
}
